import { filterSuggestionItems } from "@blocknote/core/extensions";
import {
  FormattingToolbar,
  FormattingToolbarController,
  getDefaultReactSlashMenuItems,
  getFormattingToolbarItems,
  SuggestionMenuController,
} from "@blocknote/react";
import { AIMenuController, AIToolbarButton, getAISlashMenuItems } from "@blocknote/xl-ai";
import { scriptEditorSchema } from "./scriptAiTools";
import { ReviseAIMenu } from "./ReviseAIMenu";

type ScriptEditorInstance = typeof scriptEditorSchema.BlockNoteEditor;

export function ScriptEditorMenus({
  editor,
  canRevise,
}: {
  editor: ScriptEditorInstance;
  canRevise: boolean;
}) {
  if (!canRevise) return <AIMenuController aiMenu={ReviseAIMenu} />;

  return (
    <>
      <FormattingToolbarController
        formattingToolbar={() => (
          <FormattingToolbar>
            <AIToolbarButton />
            {getFormattingToolbarItems()}
          </FormattingToolbar>
        )}
      />
      <AIMenuController aiMenu={ReviseAIMenu} />
      <SuggestionMenuController
        triggerCharacter="/"
        getItems={async (query) =>
          filterSuggestionItems(
            [...getAISlashMenuItems(editor), ...getDefaultReactSlashMenuItems(editor)],
            query
          )
        }
      />
    </>
  );
}
